import React from "react";
import "./TalkToUs.css";
import Orange_Round_Arrow_Btn from "../../Common-Component/Common_Btn/Orange_Round_Arrow_Btn/Orange_Round_Arrow_Btn";
import { Link } from "react-router-dom";
const TalkToUs = () => {
  return (
    <section className="TalkToUs">
      <div className="main_container_div">
        <div className="row">
          <div className="col-md-5 col-sm-12 col-12">
            <div className="heading_div">
              <p className="heading">Talk to Us</p>

              <p className="description">
                we go the extra mile to bring innovative ideas that make
                printing and gifting easy and fun. Try us and experience the
                difference!
              </p>
            </div>

            <div className="contact_us_btn_div">
              <Link to={"/contact"}>
                <Orange_Round_Arrow_Btn btn_name="Contact Us" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TalkToUs;
